<shared-btn [width]="'compact'" directive-cart-popup="target" class="cart-button" [feel]="bagBtnFeel" [inverted]="true"
    [badgeSize]="badgeSize" [badgeLeft]="(quantity$ | async) || 0" [badgePosition]="bagBtnBadgePosition"
    (onClick)="handleCartClick($event)">{{label}}
</shared-btn>